/**
 * Vendor program header block for assets
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';
import AppLogo from '../ui/AppLogo';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
      flex: 1,
  },
  link:  {
    color: 'blue'
  },

  [theme.breakpoints.up('sm')]: {
    tblCellLogoCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        paddingRight: 10,
        width: 52,
        maxWidth: 52,
        verticalAlign: 'top',
        borderBottom: 0,
    },
    tblCellDescCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        paddingRight: 0,
        width: 948,
        verticalAlign: 'middle',
        borderBottom: 0,
    },
},
[theme.breakpoints.up('xs')]: {
    tblCellLogoCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 10,
        width: 52,
        maxWidth: 52,
        verticalAlign: 'top',
        borderBottom: 0,
    },
    tblCellDescCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        verticalAlign: 'middle',
        borderBottom: 0,
    }
  }

});

class VendorPartnerProgramBlockAssets extends Component {

  render() {

    const classes = this.props.classes;

    let supportAssets = [];
    let resourceAssets = [];

    let i = 0;
    for (i = 0; i < this.props.assets.length; i++) {
      let asset = this.props.assets[i];
      if (asset.assetType === 0) {
        supportAssets.push(asset);
      } else if (asset.assetType === 1) {
        resourceAssets.push(asset);
      }
    }

    // Counter for unique keys
    let counter = 0;
    return (
      <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="flex-start">
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {supportAssets.length > 0 &&
            <React.Fragment>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {'Contact ' + this.props.vpp.accountTByVendorId.accountName + ' support'}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                { supportAssets.map(link => {
                return (
                  <Typography variant="body2" key={counter++}>
                    <a href={link.assetLink} className={classes.link} rel="noreferrer" target="_blank">{link.assetTitle}</a>                         
                  </Typography>
                );
                })}
              </Grid>
            </React.Fragment>}

            {supportAssets.length > 0 && resourceAssets.length > 0 &&
            <Grid item xs={12}/>}

            {resourceAssets.length > 0 &&
            <React.Fragment>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {'Partner resources'}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                { resourceAssets.map(link => {
                return (
                  <Typography variant="body2" key={counter++}>
                        <a href={link.assetLink}  className={classes.link} rel="noreferrer" target="_blank">{link.assetTitle}</a>                         
                  </Typography>
                );
                })}
              </Grid>
            </React.Fragment>}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {this.props.vppRelationship.stage === 2 && this.props.vppRelationship.repFname &&
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="h6">
              {'Your ' + this.props.vpp.accountTByVendorId.accountName + ' representative'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item>
                  <AppLogo logoPath={this.props.vppRelationship.repImg} appName={this.props.vppRelationship.repFname + ' ' + this.props.vppRelationship.repLname} imageHeight='48px'/>  
                </Grid>
                <Grid item>
                  <Grid container spacing={0} direction="column">
                    <Grid item>
                      <Typography variant="body1">{this.props.vppRelationship.repFname + ' ' + this.props.vppRelationship.repLname}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1"><a href={`mailto:${this.props.vppRelationship.repEmail}`}>{this.props.vppRelationship.repEmail}</a></Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>}
        </Grid>
      </Grid>
    );
  }
}
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockAssets);